<template>
  <div class="point-record">
    <div class="record__header">
      <div class="record__header-points">{{ points }}</div>
      <div class="record__header-label">可用积分</div>
    </div>
    <div class="record__content">
      <div class="record__content-header">积分明细</div>
      <div class="record__items">
        <div class="record__item-header">
          <div class="record__item-name">名称</div>
          <div class="record__item-points">积分</div>
          <div class="record__item-time">时间</div>
        </div>
        <div class="record__item" v-for="points in pointsDetailList" :key="points.id">
          <div class="record__item-name">{{ points.name }}</div>
          <div :class="[points.points > 0 ? 'record__item-points__red' : 'record__item-points' ]">
            {{ points.points > 0 ? `+${points.points}` : points.points }}
          </div>
          <div class="record__item-time">{{ formateDate(points.modTime) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRef, onMounted } from 'vue'
import { formateDate } from '@/utils'
import api from '@/api'

export default {
  setup() {
    const data = reactive({
      points: 0,
      pointsDetailList: []
    })

    onMounted(() => {
      api.getPoints({ activityCode: 1001 }).then(res => {
        data.points = res.data
      })
      
      api.getPointsDetail().then(res => {
        data.pointsDetailList = res.data
      })
    })

    return {
      points: toRef(data, 'points'),
      pointsDetailList: toRef(data, 'pointsDetailList'),
      formateDate
    }
  }
}
</script>

<style lang="less" scoped>
.point-record {
   min-height: 100vh;
  .record__header {
    width: 375px;
    height: 140px;
    background-image: url('../../assets/points-record-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .record__header-points {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
    .record__header-label {
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #F4F4F4;
      margin-top: 9px;
    }
  }
  .record__content {
    .record__content-header {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 12px;
      margin-left: 13px;
      margin-right: 13px;
      padding-bottom: 12px;
      border-bottom: 1px solid #F5F5F5;
    }
    .record__items {
      .record__item-header {
        display: flex;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        margin: 0 13px;
        padding: 12px 0 10px 0;
        border-bottom: 1px solid #F5F5F5;

      }
      .record__item {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        display: flex;
        margin: 0 13px;
        padding: 12px 0 10px 0;
        border-bottom: 1px solid #F5F5F5;
      }
      .record__item-name {
        width: 120px;
        padding-left: 20px;
      }
      .record__item-points {
        width: 80px;
        padding-left: 20px;
      }
      .record__item-points__red {
        width: 80px;
        padding-left: 20px;
        color: #D7313B;
      }
      .record__item-time {
        flex: 1;
        padding-left: 20px;
      }
    }
  }
}
</style>